import styled, { css } from 'styled-components';

export const SliderWrapper = styled.div<{
  $hasDots?: boolean;
  $innerShadowLeft?: boolean;
  $innerShadowRight?: boolean;
}>`
  &&&& {
    position: relative;
    text-align: left;

    .slick-track {
      display: flex;
    }
    .slick-arrow {
      z-index: 2;
      &.slick-disabled {
        display: none !important;
      }

      &::before {
        content: unset;
      }
    }

    ${({ $innerShadowLeft }) =>
      $innerShadowLeft &&
      css`
        .ant-carousel {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            box-shadow: inset 500px 0 500px -290px var(--v3-black-0);
            z-index: 1;
            pointer-events: none !important;
          }

          & .slick-arrow.slick-prev {
            box-shadow: 0 0 20px 5px var(--v3-black-6);
          }
        }
      `}

    ${({ $innerShadowRight }) =>
      $innerShadowRight &&
      css`
        .ant-carousel {
          &::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 50%;
            height: 100%;
            box-shadow: inset -500px 0 500px -270px var(--v3-black-0);
            z-index: 1;
            pointer-events: none !important;
          }

          & .slick-arrow.slick-next {
            box-shadow: 0 0 20px 5px var(--v3-black-6);
          }
        }
      `}

    ${props =>
      props.$hasDots &&
      css`
        .ant-carousel {
          .slick-dots {
            background-color: var(--v3-black-0);

            li {
              button {
                color: var(--v3-black-6);
                font-size: 0;
                background: var(--v3-black-6);
                border: 0;
                outline: none;
                cursor: pointer;
                opacity: 0.3;
                transition: all 0.5s;
                width: 16px;
                height: 16px;
                border-radius: 50%;
              }
            }

            .slick-active {
              button {
                color: var(--v3-black-25);
                background: var(--v3-black-25);
              }
            }
          }
        }

        .ant-carousel .slick-dots-bottom {
          bottom: 25px;
        }
      `};
  }
`;

export const Arrow = styled.span`
  &&& {
    top: 50%;
    margin: 0;
    width: 44px;
    height: 44px;
    padding: 10px;
    z-index: 1;
    opacity: 0.85;
    border-radius: 100%;
    align-items: center;
    display: flex !important;
    color: var(--v3-black-85);
    transform: translateY(-50%);
    background: var(--v3-black-0);
    font-size: 24px;
    &:hover {
      background: var(--v3-black-1);
      color: var(--v3-black-85);
    }
    &.slick-next {
      right: 10px;
      transform: translateY(-50%) rotate(180deg);
    }
    &.slick-prev {
      left: 10px;
    }
  }
`;
